import React, { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  ListItemText,
  Checkbox,
  OutlinedInput,
  Chip,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Grid,
  ListItemButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BlackWhiteSwitch from '../components/common/BlackWhiteSwitch';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import Tooltip from '../components/common/Tooltip';
import { Theme, useTheme } from '@mui/material/styles';

// Mock data creation
function createData(
  servicesFeesName: string,
  countryMarket: string,
  customerGroup: string,
  supplier: string,
  officeID: string,
  journeyType: string,
  cabinClass: string,
  firstDetails: Record<string, string>
) {
  return {
    servicesFeesName,
    countryMarket,
    customerGroup,
    supplier,
    officeID,
    journeyType,
    cabinClass,
    firstDetails
  };
}

// Sample rows
const rows = [
  createData(
    'Fee A',
    'India',
    'Retail',
    'Supplier X',
    'OFF101',
    'Round-Trip',
    'Economy',
    {
      'Brand Fares': 'Brand A',
    'Flight Type': 'Domestic',
    'From Date': '2023-01-01',
    'To Date': '2023-12-31',
    'Fare Type': 'Discounted',
    'Airlines Name': 'Airline A',
    'From Country': 'India',
    'To Country': 'USA',
    'From Any Airport': 'Yes',
    'To Any Airport': 'No',
    'Currency': 'INR',
    'Equipement Type': 'Airbus A320',
    'Markup by Passenger Type': 'Percentage',
    'Services Fees On': 'Yes',
    'Markup Type': 'Percentage',
    'Value USD $': '15',
    'Tiered Markup (Price Band)': 'No',
    'Payment Method Surcharge': 'No',
    'Status': 'Active',
    }
  ),
];

// Subtable fields
const fareFields = ['Brand Fares', 'Flight Type', 'From Date', 'To Date', 'Fare Type', 'Airlines Name', 'From Country', 'To Country', 'From Any Airport', 'To Any Airport'];
const airlineFields = ['Currency', 'Device Type', 'Markup by Passenger Type', 'Services Fees On', 'Markup Type', 'Value USD $', 'Tiered Markup (Price Band)', 'Payment Method Surcharge', 'Status'];



// Subtable component
function HorizontalSubtable({
  title,
  fields,
  firstDetails,
}: {
  title: string;
  fields: string[];
  firstDetails: Record<string, string>;
}) {
  return (
    <>
    
    <Box mb={4} className="innerTable">
      <Table size="small">
        <TableHead>
          <TableRow>
            {fields.map((field) => (
              <TableCell key={field} sx={{ fontWeight: 'bold' }}>{field}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {fields.map((field) => (
              <TableCell
              key={field}
              className={
                field === 'Status'
                  ? firstDetails[field] === 'Active'
                    ? 'ActiveClass'
                    : 'InActiveClass'
                  : undefined
              }
            >
              {firstDetails[field] || '-'}
            </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
    </>
  );
}
 
// Expandable row
function Row({ row }: { row: ReturnType<typeof createData> }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
    
      <TableRow>
        <TableCell>{row.servicesFeesName}</TableCell>
        <TableCell>{row.countryMarket}</TableCell>
        <TableCell>{row.customerGroup}</TableCell>
        <TableCell>{row.supplier}</TableCell>
        <TableCell>{row.officeID}</TableCell>
        <TableCell>{row.journeyType}</TableCell>
        <TableCell>{row.cabinClass}</TableCell>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen(!open)} className="viewBtn">
            {open ? (
              <>
                View Less <KeyboardArrowUpIcon />
              </>
            ) : (
              <>
                View More <KeyboardArrowDownIcon />
              </>
            )}
          </IconButton>
        </TableCell>
        <TableCell align="center">
          <Tooltip />
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={9} style={{ paddingBottom: 0, paddingTop: 0 }} className='innerTableBG'>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={2}>
              <HorizontalSubtable
                title=""
                fields={fareFields}
                firstDetails={row.firstDetails}
              />
              <HorizontalSubtable
                title=""
                fields={airlineFields}
                firstDetails={row.firstDetails}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProp = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom' as 'bottom',
      horizontal: 'left' as 'left',
    },
    transformOrigin: {
      vertical: 'top' as 'top',
      horizontal: 'left' as 'left',
    },
    getContentAnchorEl: null, // Important for older versions of MUI v4; can omit for MUI v5+
  };

const label = [
  'Service Name',
  'Country',
  'Group',
  'Supplier',
  'Office ID',
  'Journey',
  'Cabin',
];


  const MenuAirline = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom' as 'bottom',
      horizontal: 'left' as 'left',
    },
    transformOrigin: {
      vertical: 'top' as 'top',
      horizontal: 'left' as 'left',
    },
    getContentAnchorEl: null, // Important for older versions of MUI v4; can omit for MUI v5+
  };

const airline = [
  'Emirates',
  'Singapore Airlines',
  'British Airways',
  'Qatar Airways',
  'Lufthansa',
  'Air France',
];

function getStyles(name: string, airlineName: readonly string[], theme: Theme) {
  return {
    fontWeight: airlineName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 2,
};

const AirportProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = ['Delhi', 'Mumbai', 'Chennai', 'Bangalore', 'Hyderabad'];
const checkboxLabel = { inputProps: { 'aria-label': 'Ex' } };

const initialItems: string[] = ['Mondee', 'Voyzant', 'Mystifly', 'Nuitee'];
// Main Component
export default function FlightServiceFees() {
    const [labelName, setLabelName] = React.useState<string[]>([]);
  
    const labelChange = (event: SelectChangeEvent<typeof labelName>) => {
      const {
        target: { value },
      } = event;
      setLabelName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };

  const theme = useTheme();
  const [airlineName, setAirlineName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof airlineName>) => {
    const {
      target: { value },
    } = event;
    setAirlineName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [airportName, setAirportName] = useState<string[]>([]);

  const airportChange = (event: any) => {
    const value = event.target.value;

    if (value.includes('all')) {
      // If 'all' is selected, toggle all options
      if (airportName.length === names.length) {
        setAirportName([]);
      } else {
        setAirportName(names);
      }
    } else {
      setAirportName(value);
    }
  };

  const isAllSelected = names.length > 0 && airportName.length === names.length;

  const [leftItems, setLeftItems] = useState<string[]>(['All Select', ...initialItems]);
  const [rightItems, setRightItems] = useState<string[]>([]);
  const [selectedLeft, setSelectedLeft] = useState<string[]>([]);
  const [selectedRight, setSelectedRight] = useState<string[]>([]);

  const handleToggleLeft = (item: string) => {
    setSelectedLeft((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleToggleRight = (item: string) => {
    setSelectedRight((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const moveSelected = (
    from: string[],
    to: string[],
    selected: string[],
    setFrom: React.Dispatch<React.SetStateAction<string[]>>,
    setTo: React.Dispatch<React.SetStateAction<string[]>>,
    setSelected: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    let itemsToMove = selected;

    // If "All Select" is selected, move all except "All Select"
    if (selected.includes('All Select')) {
      itemsToMove = from.filter((item) => item !== 'All Select');
    }

    setFrom(from.filter((item) => !itemsToMove.includes(item) && item !== 'All Select'));
    setTo([...to, ...itemsToMove]);
    setSelected([]);
  };

  const moveAll = (
    from: string[],
    to: string[],
    setFrom: React.Dispatch<React.SetStateAction<string[]>>,
    setTo: React.Dispatch<React.SetStateAction<string[]>>,
    setSelected: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const filtered = from.filter((item) => item !== 'All Select');
    setTo([...to, ...filtered]);
    setFrom([]);
    setSelected([]);
  };

  const renderList = (
  items: string[],
  selectedItems: string[],
  toggleFunction: (item: string) => void
) => (
  <Paper sx={{ width: 75, height: 200, overflow: 'auto', boxShadow: 'none' }}>
    <List dense role="list">
      {items.map((item) => (
        <ListItem key={item} disablePadding>
          <ListItemButton
            selected={selectedItems.includes(item)}
            onClick={() => toggleFunction(item)}
          >
            <ListItemText primary={item} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  </Paper>
);



  return (
    <>
    <Box className="headingBtnWrap">
      <Typography variant="h1">Service Fees</Typography>
      <CreateButtonWithModal modalTitle="Service Fees">
        <Box className="modalFormWrap">
          <Box component="form" className="modalForm">
            <Box className="feeModalForm">
              <Typography variant="subtitle1" gutterBottom>User Targeting</Typography>
              <Box className="feeInputFieldWrap">
              {['Services Fees Name' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
              <Typography variant="subtitle1" gutterBottom>Source</Typography>
              <Box className="feeInputFieldWrap">
              {['Country / Market', 'Customer Group' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              
              <div className="form-control inputFieldWrap healthWrap supplierWrap">
                <label>Supplier</label>
                 <Accordion className='healthAccordian'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
            <Box className="healthHeaderBox supplierBox">
                        <Box>Select Supplier</Box>
                    </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box className="healthBoxWrap supplierBoxWrap">
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Box>{renderList(leftItems, selectedLeft, handleToggleLeft)}</Box>

        <Box>
          <Grid container direction="column" alignItems="center" gap={1}>
            <Button
              variant="outlined"
              onClick={() =>
                moveSelected(leftItems, rightItems, selectedLeft, setLeftItems, setRightItems, setSelectedLeft)
              }
              disabled={selectedLeft.length === 0}
            >
              &gt;
            </Button>
            <Button
              variant="outlined"
              onClick={() => moveAll(leftItems, rightItems, setLeftItems, setRightItems, setSelectedLeft)}
              disabled={leftItems.length === 0}
            >
              All &gt;&gt;
            </Button>
            <Button
              variant="outlined"
              onClick={() => moveAll(rightItems, leftItems, setRightItems, setLeftItems, setSelectedRight)}
              disabled={rightItems.length === 0}
            >
              &lt;&lt; All
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                moveSelected(rightItems, leftItems, selectedRight, setRightItems, setLeftItems, setSelectedRight)
              }
              disabled={selectedRight.length === 0}
            >
              &lt;
            </Button>
          </Grid>
        </Box>

        <Box>{renderList(rightItems, selectedRight, handleToggleRight)}</Box>
      </Grid>
                </Box>
        </AccordionDetails>
      </Accordion>
            </div>
            <div className="form-control inputFieldWrap">
                  <label>Office ID</label>
                  <input type="text" className="inputField" />
                </div>
              </Box>
              <Typography variant="subtitle1" gutterBottom>Trip Criteria</Typography>
              <Box className="feeInputFieldWrap">
              {['Journey Type', 'Cabin Class', 'Brand Fares', 'Flight Type', 'From Date', 'To Date' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
              <Typography variant="subtitle1" gutterBottom>Route Criteria</Typography>
              <Box className="feeInputFieldWrap">
              {['Fare Type' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              
              <div className="form-control inputFieldWrap">
                <div className="multiLabel">
                  <label>Airline Name</label>
                  {airlineName.length > 1 && (
                  <div onClick={handleOpen} className='multiTitle'>Multi</div>
                  )}
                </div>
              <FormControl sx={{ minWidth: 265 }}>
           <Select
           className='airlineSelect commondropdown'
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={airlineName}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          displayEmpty
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return <span style={{ color: '#888' }}>Select Airline</span>;
            }
            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {(selected as string[]).map((value: string) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            );
          }}
          MenuProps={MenuAirline}
        >
         <MenuItem disabled value="">
              Select Airline
          </MenuItem>
          {airline.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, airlineName, theme)}
            >
              <Checkbox checked={airlineName.includes(name)} />
              <ListItemText primary={name} />
              {/* {name} */}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </div>
        {['From Country', 'To Country'].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              <div className="form-control inputFieldWrap">
                <div className="multiBoxLabel">
          <label>From Any Airport</label>
          <div>
            <FormControlLabel className="excludeLabel" control={<Checkbox {...checkboxLabel} />} label="Ex" />
            
          </div>
          </div>
          <FormControl sx={{ minWidth: 265 }}>
        <Select
          className='airlineSelect commondropdown'
          multiple
          displayEmpty
          value={airportName}
          onChange={airportChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
              if (selected.length === 0) {
                return <span style={{ color: '#888' }}>Select Airports</span>;
              }
              return selected.join(', ');
            }}
          
          MenuProps={AirportProps}
        >
          <MenuItem disabled value="">
            Select Airports
            </MenuItem>
          <MenuItem value="all" className='selectDropdown'>
            <Checkbox checked={isAllSelected} indeterminate={airportName.length > 0 && airportName.length < names.length} />
            <ListItemText primary="Select All" />
          </MenuItem>

          {names.map((name) => (
            <MenuItem key={name} value={name} className='selectDropdown'>
              <Checkbox checked={airportName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
        </div>
              </Box>
              <Typography variant="subtitle1" gutterBottom>Pricing Logic</Typography>
              <Box className="feeInputFieldWrap">
              {['Currency', 'Device Type', 'Markup by Passenger Type', 'Services Fees On', 'Value USD $', 'Tiered Markup (Price Band)', 'Payment Method Surcharge' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" className='formBtn'>Save</Button>
          </Box>
        </Box>
        <BlackWhiteSwitch />
      </CreateButtonWithModal>
    </Box>
    <Box className="searchInputWrap">
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        p={2}
        sx={{ width: '100%'}}
        className="searchInputFilterBox"
      >
        <FormControl sx={{ minWidth: 460 }}>
           <Select
            className='leftFilterBox'
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={labelName}
            onChange={labelChange}
            displayEmpty
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return 'Select';  // <-- Placeholder text
              }
              return selected.join(', ');
            }}
            MenuProps={MenuProp}
          >
            <MenuItem disabled value="">
            Select 
            </MenuItem>
            {label.map((name) => (
              <MenuItem key={name} value={name} className='selectDropdown'>
                <Checkbox checked={labelName.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        {/* <TextField
          className="leftSearchFilter"
          fullWidth
          variant="outlined"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSearch();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onClick={handleSearch} edge="start">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <Button
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                onClick={handleSearch}
              >
                Search
              </Button>
            ),
          }}
        /> */}
        <Button
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                Search
              </Button>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }} className="dynamicInputFieldWrap">
        {labelName.map((item) => (
          <div key={item} className="form-control inputFieldWrap">
            <label style={{ marginBottom: '4px', fontWeight: '500' }}>{item}</label>
            <input
              type="text"
              // placeholder={`Enter ${item}`}
              className="inputField"
            />
          </div>
        ))}
      </Box>
    </Box>
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Service Name</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>Group</TableCell>
              <TableCell>Supplier</TableCell>
              <TableCell>Office ID</TableCell>
              <TableCell>Journey</TableCell>
              <TableCell>Cabin</TableCell>
              <TableCell align="center">Actions</TableCell>
              <TableCell align="center">Audit Trail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <Row key={index} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='airlineListModal'
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Airline Name
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box>
                {airlineName.map((value) => (
                  <Chip key={value} label={value} sx={{ display: 'block' }} />
                ))}
              </Box>
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
